
import React from 'react';
import WaterKpiDashboard from '@/components/water/dashboard/WaterKpiDashboard';
import CompactLayout from '@/components/layout/CompactLayout';
import { Toaster } from '@/components/ui/toaster';

const WaterKpiDashboardPage = () => {
  return (
    <CompactLayout>
      <div className="h-[calc(100vh-4rem)] overflow-hidden">
        <WaterKpiDashboard />
      </div>
      <Toaster />
    </CompactLayout>
  );
};

export default WaterKpiDashboardPage;
